import { AssetType } from '@amzn/fire-tv-campaign-automation-service';
import shell10InchLandscape from 'public/images/tablet-shells/FireTabletsFeatureRotator_10Inch_Landscape_FOS_Shell.png';
import {
  PreviewStateConfig,
  LayerType,
  BackgroundTransformType,
  LogoTransformType,
  GradientDirection,
} from 'src/utils/preview/types';

import {
  ALT_TEXT,
  SHIFT_FACTOR,
  GRADIENT_DARK,
  GRADIENT_TRANSPARENT,
  SCRIM_START,
  SCRIM_END,
  FONT_FAMILY,
  TEXT_COLOR,
  MAX_LINES,
} from '../constants';

export const TABLET_10INCH_LANDSCAPE_FOS: PreviewStateConfig = {
  label: '10" Landscape',
  altText: ALT_TEXT,
  dimensions: { width: 1920, height: 1200 },
  layers: [
    {
      type: LayerType.BACKGROUND,
      transform: {
        type: BackgroundTransformType.CENTER_CROP,
        shiftFactor: SHIFT_FACTOR,
        x: 31,
        y: 360,
        width: 1859,
        height: 524,
      },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.HORIZONTAL,
      colorStops: [
        { position: 0, color: GRADIENT_DARK },
        { position: 1, color: GRADIENT_TRANSPARENT },
      ],
      bounds: { x: 31, y: 360, width: 929, height: 524 },
    },
    {
      type: LayerType.LOGO,
      transform: {
        type: LogoTransformType.FIT_WITHIN,
        maxWidth: 500,
        maxHeight: 203,
        position: { x: 165, y: 449 },
      },
    },
    {
      type: LayerType.TEXT,
      position: {
        x: 165,
        y: 680,
      },
      fontSize: 55,
      fontFamily: FONT_FAMILY,
      color: TEXT_COLOR,
      maxWidth: 720,
      maxLines: MAX_LINES,
      lineHeight: 66,
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_START },
        { position: 1, color: SCRIM_END },
      ],
      bounds: { x: 31, y: 360, width: 1859, height: 30 },
    },
    {
      type: LayerType.GRADIENT,
      direction: GradientDirection.VERTICAL,
      colorStops: [
        { position: 0, color: SCRIM_END },
        { position: 1, color: SCRIM_START },
      ],
      bounds: { x: 31, y: 838, width: 1859, height: 46 },
    },
    { type: LayerType.SHELL, src: shell10InchLandscape },
  ],
  assetRequirements: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
};
